export default __webpack_public_path__ + "b6f88ed9d4975f2732394fd50cd5ff80.png";